export enum SessionStorageKeys {
    currentGameParams = 'OrbitCurrentGameParams',
    retryGeoOnLoad = "OrbitRetryGeoOnLoad",
    jackpotBetsParticipationData = 'jackpotBetsParticipationData'
}